import React, { useEffect, useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Row, Switch, Tag, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';

import BasicButtonPrimary from 'components/BasicButtonPrimary';
import ThirdPartyIntegration from 'services/thirdPartyIntegrationService';
import './TingeeThirdParty.scss';
import { THIRDPARTY_CODE } from 'constants/app';
import { getThirdPartyIdFromStationIntegrationList } from './helpers/thirdPartyIntegrationHelper';

const BaoKim = ({ id, setOpenContent, setId }) => {
  const { t: translation } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (id) {
      handleGetData(id);
    }
  }, [id]);

  const handleSetupData = (res = {}) => {
    const partyRequiredData = JSON.parse(res?.partyRequiredData || '{}');
    const connected = res?.partyActiveStatus === 1;

    form.setFieldsValue({
      merchant_code: partyRequiredData?.merchant_code,
      client_id: partyRequiredData?.client_id,
      client_secret: partyRequiredData?.client_secret,
      isConnected: connected,
      isEnable: res?.partyEnableStatus === 1,
    });
    setIsConnected(connected);
  };

  const handleGetData = async (targetId = id) => {
    if (!targetId) return;
    try {
      setLoading(true);
      const res = await ThirdPartyIntegration.getThirdPartyById({ id: targetId });
      handleSetupData(res);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleTestBaoKim = async (showError = true, valuesArg) => {
    try {
      setLoading(true);
      let values = valuesArg || form.getFieldsValue(true);
      const payload = {
        merchant_code: values.merchant_code,
        client_id: values.client_id,
        client_secret: values.client_secret,
        amount: 10000,
      };
      const result = await ThirdPartyIntegration.testConfigsBaoKimBusiness(payload);
      if (result) {
        setIsConnected(true);
        form.setFieldsValue({ isConnected: true });
        notification['success']({
          message: '',
          description: translation('vietqr.successMessage'),
        });
        return true;
      }
      return false;
    } catch (error) {
      if (showError) {
        notification['error']({
          message: '',
          description: translation('vietqr.errorMessage'),
        });
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateConfig = async (values) => {
    try {
      setLoading(true);
      let isConnectedLocal = isConnected;

      if (!isConnectedLocal) {
        const testSuccess = await handleTestBaoKim(true, values);
        if (!testSuccess) return;
        isConnectedLocal = true;
        values = { ...values, isEnable: true };
        form.setFieldsValue({ isEnable: true, isConnected: true });
      }

      const payload = {
        data: {
          partyRequiredData: {
            merchant_code: values.merchant_code,
            client_id: values.client_id,
            client_secret: values.client_secret,
          },
          partyActiveStatus: isConnectedLocal ? 1 : 0,
          partyEnableStatus: values.isEnable ? 1 : 0,
        },
      };

      await ThirdPartyIntegration.updateConfigsBaoKimBusiness(payload);
      const updatedThirdPartyId = await getThirdPartyIdFromStationIntegrationList(THIRDPARTY_CODE.BAOKIM_BUSINESS);
      if (!updatedThirdPartyId) {
        throw new Error('BAOKIM_ID_NOT_FOUND_FROM_LIST');
      }
      if (Number(updatedThirdPartyId) !== Number(id)) {
        setId(updatedThirdPartyId);
      } else {
        await handleGetData(updatedThirdPartyId);
      }
      notification['success']({
        message: '',
        description: translation('tingee.updateSuccess'),
      });
    } catch (error) {
      notification['error']({
        message: '',
        description: translation('tingee.updateError'),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='tingee-noti'>
      <Button type='default' icon={<LeftOutlined />} onClick={() => setOpenContent('')} />
      <Card loading={loading} className='telegram-noti_content'>
        <div className='mt-2'>
          <Form form={form} layout='vertical' onFinish={handleUpdateConfig}>
            <Row gutter={[48, 16]}>
              <Col xs={{ span: 24 }} md={{ span: 20 }} span={20}>
                <div className='section-title mb-2 mt-3'>{translation('expand_setting.BAOKIM_BUSINESS')}</div>
                <Form.Item required label='Merchant Code' name='merchant_code' rules={[{ required: true, message: translation('isReq') }]}> 
                  <Input type='text' />
                </Form.Item>
                <Form.Item required label='Client ID' name='client_id' rules={[{ required: true, message: translation('isReq') }]}> 
                  <Input type='text' />
                </Form.Item>
                <Form.Item required label='Client Secret Key' name='client_secret' rules={[{ required: true, message: translation('isReq') }]}> 
                  <Input type='text' />
                </Form.Item>
                <Form.Item label={translation('telegram.active')} name='isEnable' valuePropName='checked'>
                  <Switch />
                </Form.Item>
                <Form.Item className='pt-1' label={translation('telegram.connectionStatus')}>
                  <Tag color={form.getFieldValue('isConnected') ? 'green' : ''}>
                    {form.getFieldValue('isConnected') ? translation('telegram.connected') : translation('telegram.notConnected')}
                  </Tag>
                </Form.Item>
                <BasicButtonPrimary
                  style={{ marginRight: 10 }}
                  className='mr-2'
                  htmlType='submit'
                  text={translation('telegram.updateButton')}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </Card>
    </div>
  );
};

export default BaoKim;
